import React from 'react';
import { Button, Col, Row, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import TextInput from '../../common/controls/textInput';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
import Icon from '../../common/containers/icon';
const FacilityGroupArea = _ref => {
  let facilityGroupArea = _ref.facilityGroupArea,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove,
    index = _ref.index;
  const handleChange = (name, value) => onChange(index, name, value);
  const removeFGA = () => removeItemWithConfirm(facilityGroupArea, 'Facility Group Area', ['name'], onRemove.bind(null, index));
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 7,
      offset: 2
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Area Name",
    field: "name",
    data: facilityGroupArea,
    onChange: handleChange,
    entity: "FacilityGroupArea"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "form-control t-fga-remove-area tqc-control",
    onClick: removeFGA
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Area")));
};
FacilityGroupArea.propTypes = {
  index: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  facilityGroupArea: PropTypes.shape({
    id: PropTypes.string
  }).isRequired
};
export default FacilityGroupArea;